import clsx from 'clsx'
import React from 'react'
import stylesQrCom from './qrcom.module.css';
import ImageComponent from '../ImageComponent';
// import GooglePeSVG from '../../assets/verticalpayments/googlepay.png';
// import PaytmSVG from '../../assets/verticalpayments/paytm.png';
// import PaySafeSVG from '../../assets/verticalpayments/pay.png';
// import PayUpiSVG from '../../assets/verticalpayments/gpay.png';
// import PhonePeSVG from '../../assets/verticalpayments/phonepay.png';


export default function PaymentIcons({ paymentConsentText, bottomSpaceClass, topSpaceClass, upiLogos }: { paymentConsentText: string, bottomSpaceClass: string, topSpaceClass: string, upiLogos: any[] }) {
  return (
    <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecColumn, stylesQrCom.justifyContentCenter, stylesQrCom.wperc100, stylesQrCom.gap4, stylesQrCom.alignItemsCenter, stylesQrCom[bottomSpaceClass], stylesQrCom[topSpaceClass])}>
        <span className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.fontWeight400, stylesQrCom.lineHeight20, stylesQrCom.fontSize12)}>{paymentConsentText}</span>


        <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.flexDirecRow, stylesQrCom.justifyContentCenter, stylesQrCom.wperc100, stylesQrCom.gap4, stylesQrCom.alignItemsCenter)}>

           
            {upiLogos.map((upiLogo: any, index: number) => (
              <div key={index} className={clsx(stylesQrCom.paymentIconWrapper)}><ImageComponent src={upiLogo} style={{ width: '32px', height: '32px' }} alt="UPI Logo" /></div>
            ))}


        </div>
            
    </div>
  )
}
